import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=b822642c&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b822642c')) {
      api.createRecord('b822642c', component.options)
    } else {
      api.reload('b822642c', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=b822642c&", function () {
      api.rerender('b822642c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23ho07D2vrbu6/JS/comp/starrating.vue"
export default component.exports